<app-header></app-header>
<ion-content
  id="all-deals"
  class="gray-content-bg"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
>
  <div class="all-deals-header">
    <ion-grid [fixed]="true">
      <!-- Row for Breadcrumbs -->
      <ion-row
        *ngIf="platformService?.platformType !== platformService?.platformEnum.mobile"
      >
        <ion-col size="12">
          <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        </ion-col>
      </ion-row>

      <!-- Row for Header -->
      <ion-row>
        <ion-col size="12">
          <h2 data-cy="all-deals-page-header-text">
            {{ 'i18n.deals.allDeals' | translate | uppercase }}
          </h2>
        </ion-col>
        <div
          *ngIf="platformService?.platformType === platformService?.platformEnum.mobile"
          data-cy="all-deals-page-header-count-text"
          class="count"
        >
          ({{products?.length}} {{ 'i18n.deals.countText' | translate }})
        </div>
      </ion-row>
    </ion-grid>
  </div>

  <ion-grid [fixed]="true" class="card-grid">
    <div
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      class="desktop-cards-container"
    >
      <app-usf-product-card-desktop
        *ngFor="let item of products; let i = index; trackBy: trackItem"
        [vm]="{
          mode: mode,
          product: item,
          index: i,
          pricingDisabled: false,
          isOnline: (panAppState.online$ | async)
        }"
        (quantityUpdateEmitter)="updateQuantity($event)"
        (ellipsisEmitter)="clickEllipsis($event)"
        (promotionClickEmitter)="clickPromotions($event)"
        (productCardClickEmitter)="clickCard($event)"
        (infoIconClickEmitter)="clickInfo($event)"
      >
      </app-usf-product-card-desktop>
    </div>

    <div
      *ngIf="(platformService?.isTouchExperience$ | async)"
      class="touch-cards-container"
    >
      <app-usf-product-card-touch
        *ngFor="let item of products; let i = index; trackBy: trackItem"
        [vm]="{
          mode: mode,
          product: item,
          index: i,
          pricingDisabled: false,
          isOnline: (panAppState.online$ | async)
        }"
        (quantityUpdateEmitter)="updateQuantity($event)"
        (ellipsisEmitter)="clickEllipsis($event)"
        (promotionClickEmitter)="clickPromotions($event)"
        (productCardClickEmitter)="clickCard($event)"
        (infoIconClickEmitter)="clickInfo($event)"
      >
      </app-usf-product-card-touch>
    </div>
  </ion-grid>

  <app-footer></app-footer>
</ion-content>
